export default "__VITE_ASSET__BEkozPPm__"